const {includes} = require("underscore");
const {getGroups} = require("./claims.js");

const TIERS = ["Foundations", "Professional", "Global"];
const TIER_RANK = {Foundations: 0, Professional: 1, Global: 2};

const hasAdminGroup = (user) => includes(getGroups(user), "Admin");
const hasRegulationAdminGroup = (user) => includes(getGroups(user), "RegulationAdmin");
const hasAnyAdminGroup = (user) => hasAdminGroup(user) || hasRegulationAdminGroup(user);
const hasFoundationsGroup = (user) => includes(getGroups(user), "Foundations");
const hasProfessionalGroup = (user) => includes(getGroups(user), "Professional");
const hasGlobalGroup = (user) => includes(getGroups(user), "Global");
const hasEnterpriseGroup = (user) => includes(getGroups(user), "Enterprise");
const hasHighTierGroup = (user) => hasGlobalGroup(user) || hasEnterpriseGroup(user);

const getUserTierFromGroups = (user) => {
  if (hasAdminGroup(user) || hasRegulationAdminGroup(user) || hasHighTierGroup(user)) {
    return "Global";
  }
  if (hasProfessionalGroup(user)) {
    return "Professional";
  }
  return "Foundations";
};

const resolveHighestTier = (userTier = "Foundations", orgTier) => {
  if (!orgTier) {
    return userTier;
  }
  return TIER_RANK[orgTier] >= TIER_RANK[userTier] ? orgTier : userTier;
};

const hasRegScoutAgentAccess = (user, orgTier) => {
  const effectiveTier = resolveHighestTier(getUserTierFromGroups(user), orgTier);
  return hasAnyAdminGroup(user) || includes(["Professional", "Global"], effectiveTier);
};

const hasAnyRegScoutGroup = (user) => {
  return (
    hasAdminGroup(user) ||
    hasRegulationAdminGroup(user) ||
    hasFoundationsGroup(user) ||
    hasProfessionalGroup(user) ||
    hasHighTierGroup(user)
  );
};

const getUserTierFromGroupsAndOrg = (user, orgLevel) => {
  if (hasEnterpriseGroup(user) || orgLevel === "Enterprise") {
    return "Enterprise";
  }
  if (hasHighTierGroup(user) || orgLevel === "Global") {
    return "Global";
  }
  if (hasProfessionalGroup(user) || orgLevel === "Professional") {
    return "Professional";
  }
  return "Foundations";
};

const hasHighTierGroupOrOrg = (user, orgLevel) =>
  hasHighTierGroup(user) || includes(["Global", "Enterprise"], orgLevel);

const hasPaidGroupOrOrg = (user, orgLevel) =>
  hasAnyAdminGroup(user) ||
  hasHighTierGroupOrOrg(user, orgLevel) ||
  hasProfessionalGroup(user) ||
  orgLevel === "Professional";

module.exports = {
  TIERS,
  TIER_RANK,
  hasAdminGroup,
  hasRegulationAdminGroup,
  hasAnyAdminGroup,
  hasFoundationsGroup,
  hasProfessionalGroup,
  hasGlobalGroup,
  hasEnterpriseGroup,
  hasHighTierGroup,
  getUserTierFromGroups,
  getUserTierFromGroupsAndOrg,
  resolveHighestTier,
  hasRegScoutAgentAccess,
  hasAnyRegScoutGroup,
  hasHighTierGroupOrOrg,
  hasPaidGroupOrOrg,
};
